module.exports = __webpack_public_path__ + "img/4902720092081_1.e524374b.jpg";